import { QueryKeys } from "@/lib/types";

export function userBalanceDetailsQueryKey(userId: number) {
  return [QueryKeys.Balance, "user", userId, "details"] as const;
}
